exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://use.fontawesome.com/releases/v5.0.13/css/all.css);", ""]);

// module
exports.push([module.id, ".skills-container{width:100%;margin-top:13vh}.skills-content{box-sizing:border-box;width:100%;margin:auto;font-family:comfortaa}.skills-header{text-align:center;transform:translate(-50%);margin-bottom:-30px}.skills-header>button{font-size:20px;color:#474747}.skills-header>.active-btn,.skills-header>button{background-color:transparent;text-align:center;border:none;cursor:pointer;outline:none;margin-left:0}.skills-header>.active-btn{color:#ff4d5a}.wrapper{position:relative;margin:auto;padding:1rem;max-width:600px}.chart-container{min-width:250px;font-family:comfortaa}@media(max-width:1069px){.skills-content{font-family:comfortaa}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f42e387c","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Skills.vue
// module id = 282
// module chunks = 0